var TABS_VC_COVER_DELAY_MS = 1500;
var YT_READY = false;
var YT_QUEUE = [];

window.onYouTubeIframeAPIReady = function () {
    YT_READY = true;
    YT_QUEUE.forEach(function (fn) { fn(); });
    YT_QUEUE = [];
};

function loadYT(cb) {
    if (window.YT && window.YT.Player) {
        YT_READY = true;
        cb();
        return;
    }
    if (YT_QUEUE.indexOf(cb) === -1) YT_QUEUE.push(cb);
    if (window.__tabsVcYT) return;
    window.__tabsVcYT = true;
    if (document.querySelector('script[src*="youtube.com/iframe_api"]')) return;
    var s = document.createElement('script');
    s.src = 'https://www.youtube.com/iframe_api';
    s.async = true;
    document.head.appendChild(s);
}

// The cover thumbnail stands in for the video until the first play. The YouTube API and each
// card's player are created on that first click/tap instead of on page load, which used to pull
// ~1.5-2.3 MB of YouTube files into every PDP before anyone pressed play.
function initTabsVcVideo() {
    document.querySelectorAll('.tabs-vc-card').forEach(function (card) {
        var cover = card.querySelector('.tabs-vc-card__cover');
        var container = card.querySelector('.tabs-vc-card__player');
        var id = card.getAttribute('data-youtube-id');
        if (!cover || !container || !id) return;

        var coverTimeout = null;
        var player = null;
        var playerReady = false;

        function showCoverLater() {
            coverTimeout = setTimeout(function () {
                coverTimeout = null;
                card.classList.remove('is-playing');
            }, TABS_VC_COVER_DELAY_MS);
        }

        function cancelCoverTimeout() {
            if (coverTimeout) {
                clearTimeout(coverTimeout);
                coverTimeout = null;
            }
        }

        function createPlayer() {
            player = new window.YT.Player(container, {
                videoId: id,
                width: '100%',
                height: '100%',
                // autoplay: the player is only created after the user asked to play.
                playerVars: { autoplay: 1, playsinline: 1, rel: 0 },
                events: {
                    onReady: function (e) {
                        playerReady = true;
                        card.classList.add('is-playing');
                        e.target.playVideo();
                    },
                    onStateChange: function (e) {
                        if (e.data === 2 || e.data === 0) {
                            cancelCoverTimeout();
                            showCoverLater();
                        }
                    }
                }
            });
        }

        // On the first play the cover stays up until the player is ready (onReady swaps them),
        // so the card never shows an empty black box while YouTube loads.
        function play() {
            cancelCoverTimeout();
            if (playerReady) {
                card.classList.add('is-playing');
                player.playVideo();
            } else if (!player) {
                loadYT(createPlayer);
            }
        }

        // Start fetching the API as soon as the user shows intent, so the first play feels instant.
        function warmUp() {
            if (!window.__tabsVcYT) loadYT(function () {});
        }
        cover.addEventListener('pointerenter', warmUp, { once: true });
        cover.addEventListener('focus', warmUp, { once: true });

        var touchStartX = 0;
        var touchStartY = 0;
        var isDragging = false;
        var tapThreshold = 100;

        cover.addEventListener('touchstart', function (e) {
            warmUp();
            touchStartX = e.touches[0].clientX;
            touchStartY = e.touches[0].clientY;
            isDragging = false;
        }, { passive: true });

        cover.addEventListener('touchmove', function (e) {
            var dx = e.touches[0].clientX - touchStartX;
            var dy = e.touches[0].clientY - touchStartY;
            if (dx * dx + dy * dy > tapThreshold) isDragging = true;
        }, { passive: true });

        cover.addEventListener('touchend', function (e) {
            if (!isDragging) {
                e.preventDefault();
                e.stopPropagation();
                play();
            }
        }, { passive: false });

        cover.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            play();
        });

        cover.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                play();
            }
        });
    });
}

function boot() {
    initTabsVcVideo();
}
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
} else {
    boot();
}

window.TabsVideoCardsSlider = TabsSliderFactory({
    sliderClass: 'tabs-vc-slider',
    prefix: 'vc',
    swiperOptions: {
        spaceBetween: 20,
        breakpoints: { 768: { spaceBetween: 24 } },
        mousewheel: { enabled: true, forceToAxis: true, sensitivity: 1, releaseOnEdges: true },
        simulateTouch: true,
        allowTouchMove: true,
        touchRatio: 1.5,
        resistance: true,
        resistanceRatio: 0.85,
    }
});
